// client/src/components/pages/ServicesPage.js
import React, { useState, useEffect } from 'react';
import { useParams, useLocation, Link, NavLink } from 'react-router-dom';
import './ServicesPage.css'; // We will create this new CSS file next

// --- This is the single source of truth for all your service content ---
const servicesData = {
  'maintenance-repair': {
    title: 'Maintenance & Repair',
    subtitle: 'Maximizing Equipment Uptime, Ensuring Clinical Reliability',
    content: 'In a critical healthcare environment, equipment downtime is not an option. Our certified technicians provide comprehensive preventative maintenance, emergency on-site repairs, and use only genuine spare parts to safeguard your investment and ensure patient care is never compromised.'
  },
  'consultation-training': {
    title: 'Consultation & Training',
    subtitle: 'Empowering Your Team, Optimizing Your Clinical Workflow',
    content: 'The right equipment is only half the equation. We offer expert consultation for workflow optimization and facility planning, alongside hands-on training for both clinical and biomedical staff to bridge the gap between technology and practice.'
  },
  'managed-supply': {
    title: 'Managed Supply Chain',
    subtitle: 'The Right Supplies, Right On Time, Every Time',
    content: 'Take the logistical burden off your shoulders. Our managed supply service implements an intelligent supply chain with proactive inventory management and automated reordering, ensuring you never run out of what you need while minimizing waste.'
  }
};
const serviceSlugs = Object.keys(servicesData);

const ServicesPage = () => {
  const { serviceSlug } = useParams();
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  // Re-trigger animation when the service (and thus the pathname) changes
  useEffect(() => {
    setIsVisible(false);
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, [pathname]);

  // Determine which service to display. Default to the first one if no slug is in the URL.
  const currentService = servicesData[serviceSlug] || Object.values(servicesData)[0];

  return (
    <div className={`services-page-container ${isVisible ? 'is-visible' : ''}`}>
      <header className="services-page-header">
        <h1>Our Services</h1>
        <p>Comprehensive support solutions for Tanzania's healthcare sector.</p>
      </header>
      <div className="services-page-layout">
        <aside className="services-sidebar">
          <h4>Service Offerings</h4>
          <ul>
            {serviceSlugs.map(slug => (
              <li key={slug}>
                <NavLink to={`/services/${slug}`} className={({isActive}) => isActive ? 'active' : ''}>
                  {servicesData[slug].title}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>

        <main className="service-content-main">
          <h2>{currentService.title}</h2>
          <p className="service-subtitle">{currentService.subtitle}</p>
          <div className="service-main-text">
            {currentService.content}
          </div>
          <div className="service-cta">
            <p>Ready to enhance your operations?</p>
            <Link to="/contact" className="btn btn-primary">Contact Us for Details</Link>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ServicesPage;